import React from "react";
import CouponStatusBadge from "./CouponStatusBadge";
import { COLORS, formatDate } from "./couponUi";

export default function CouponCardShell({
  title,
  status,
  activationDate,
  expiryDate,
  loading = false,
  error = null,
  onRetry,
  empty = false,
  children,
}) {
  return (
    <section
      style={{
        backgroundColor: COLORS.white,
        border: `1px solid ${COLORS.mediumGrey}`,
        borderRadius: 12,
        padding: 20,
      }}
    >
      <header
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 8,
          marginBottom: 12,
        }}
      >
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: COLORS.darkText }}>
          {title}
        </h3>
        {status ? <CouponStatusBadge status={status} /> : null}
        <div
          style={{
            marginLeft: "auto",
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 12,
            color: COLORS.mediumText,
          }}
        >
          <span>
            Activated: <strong style={{ color: COLORS.darkText }}>{formatDate(activationDate)}</strong>
          </span>
          <span>
            Expires: <strong style={{ color: COLORS.darkText }}>{formatDate(expiryDate)}</strong>
          </span>
        </div>
      </header>

      {loading ? (
        <div
          role="status"
          aria-label="Loading coupon"
          style={{ padding: "24px 0", textAlign: "center", color: COLORS.mediumText, fontSize: 13 }}
        >
          <span
            style={{
              display: "inline-block",
              width: 22,
              height: 22,
              border: `3px solid ${COLORS.mediumGrey}`,
              borderTopColor: COLORS.aquaBlue,
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
              marginBottom: 8,
            }}
          />
          <div>Loading…</div>
        </div>
      ) : null}

      {!loading && error ? (
        <div
          role="alert"
          style={{
            backgroundColor: COLORS.errorBg,
            border: `1px solid ${COLORS.errorBorder}`,
            borderRadius: 12,
            padding: 20,
            textAlign: "center",
          }}
        >
          <p style={{ color: COLORS.errorText, fontSize: 14, margin: 0 }}>{error.message}</p>
          {onRetry ? (
            <button
              type="button"
              onClick={onRetry}
              style={{
                marginTop: 12,
                backgroundColor: COLORS.white,
                border: `1px solid ${COLORS.mediumGrey}`,
                borderRadius: 6,
                padding: "8px 16px",
                cursor: "pointer",
                fontSize: 13,
              }}
            >
              Retry
            </button>
          ) : null}
        </div>
      ) : null}

      {!loading && !error && empty ? (
        <p
          style={{
            margin: 0,
            padding: "16px 0",
            textAlign: "center",
            color: COLORS.mediumText,
            fontSize: 13,
          }}
        >
          No coupon assigned for this family
        </p>
      ) : null}

      {!loading && !error && !empty ? children : null}

      <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
    </section>
  );
}
